import api from '../api/axios';

export const addDriverUser = async data => {
  const response = await api.post('driver/add/', data);
  return response.data;
};

export const getAllDrivers = async () => {
  const response = await api.get('driver/');
  return response.data;
};

export const getDrivers = async supervisor_id => {
  const response = await api.get(`driver/supervisor/?id=${supervisor_id}`);
  return response.data;
};

export const getDashboard = async () => {
  const response = await api.get(`/dashboard`);
  return response.data;
};

export const getDriverAttendance = async (selDriver, frmDate) => {
  const response = await api.get(`/driver/daily/data/${selDriver}/?date=${frmDate}`);
  return response.data;
};

export const getDriverAttendanceBySupervisor = async (supervisor, frm, to, id) => {
  const query = new URLSearchParams();
  if (supervisor) {
    query.append('supervisor_id', supervisor);
  }
  if (id) {
    query.append('ids', id);
  }
  query.append('from', frm);
  query.append('to', to);

  const response = await api.get(`/driver/attendance/?${query.toString()}`);
  return response.data;
};

export const getDriverAttendanceByMonth = async (supervisor, frm, id) => {
  const query = new URLSearchParams();
  if (supervisor) {
    query.append('supervisor_id', supervisor);
  }
  if (id) {
    query.append('ids', id);
  }
  query.append('month', frm);

  const response = await api.get(`/driver/attendance/?${query.toString()}`);
  return response.data;
};

export const updateDriverUser = async data => {
  const response = await api.patch('driver/edit/', data);
  return response.data;
};

export const deleteDriver = async id => {
  const response = await api.delete(`/driver/delete/${id}/`);
  return response.data;
};
